import { Alert } from '@ui-components/neo.tax';
import React from 'react';

type GithubEmailMappingSectionProps = {
  isOpeningUploader: boolean;
  isVisible: boolean;
  onUpload: () => void;
};

export const GithubEmailMappingSection = ({
  isOpeningUploader,
  isVisible,
  onUpload,
}: GithubEmailMappingSectionProps): React.ReactElement => {
  if (!isVisible) {
    return <></>;
  }

  return (
    <Alert
      severity="warning"
      title="Upload GitHub to Email mapping"
      subtitle="Upload a file mapping each GitHub username to a work email. This is necessary because GitHub hides member emails. Make sure to do this step before uploading payroll, so it matches correctly."
      actions={[
        {
          label: 'Upload GitHub Emails',
          // The importer needs a signed URL and a OneSchema token before it can render, so the button
          // stays busy rather than looking unresponsive for those few seconds.
          isLoading: isOpeningUploader,
          onClick: onUpload,
        },
      ]}
    />
  );
};
